import { render, staticRenderFns } from "./usercenter.vue?vue&type=template&id=4270db3c&scoped=true"
import script from "./usercenter.vue?vue&type=script&lang=js"
export * from "./usercenter.vue?vue&type=script&lang=js"
import style0 from "./usercenter.vue?vue&type=style&index=0&id=4270db3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4270db3c",
  null
  
)

export default component.exports